import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import findNestedValue from '@shared/utils/findNestedValue';

const createNestedDynamicSchema = (
	schema,
	fields,
	fieldDotNotationString,
	requiredDotNotationString,
) => {
	const newSchema = { ...schema };
	Object.keys(newSchema).map((item) => {
		const isSchema = yup.isSchema(newSchema[item]);
		const foundField = fields?.find((field) => {
			const found = findNestedValue(field, fieldDotNotationString);
			return found?.toLowerCase() === item?.toLowerCase();
		});

		if (foundField) {
			const isRequired = findNestedValue(
				foundField,
				requiredDotNotationString,
			);

			if (isRequired) {
				// const itemDependencies = newSchema[item].deps;
				// if (itemDependencies.length > 0) {
				// 	newSchema[item] = newSchema[item].when(
				// 		itemDependencies[0],
				// 		{
				// 			is: true,
				// 			then: newSchema[item].required(
				// 				{ value: 'requireField', action: 't', params: {} },
				// 			),
				// 		},
				// 	);
				// }

				newSchema[item] = newSchema[item].required(
					{ value: 'requireField', action: 't', params: {} },
				);

				if (newSchema[item].type === 'array') {
					newSchema[item] = newSchema[item].min(
						1,
						{ value: 'atLeastOneItemIsRequired', action: 't', params: {} },
					);
				}
			}
		} else if (Array.isArray(newSchema[item])) {
			const nestedSchema = createNestedDynamicSchema(
				{ ...newSchema[item][0] },
				fields,
				fieldDotNotationString,
				requiredDotNotationString,
			);
			newSchema[item] = yup.array().of(yup.object().shape(nestedSchema));
			// } else if((typeof newSchema[item] === 'object') && !Array.isArray(newSchema[item]) ) {
		} else if (!isSchema) {
			const nestedSchema = createNestedDynamicSchema(
				{ ...newSchema[item] },
				fields,
				fieldDotNotationString,
				requiredDotNotationString,
			);
			newSchema[item] = yup.object().shape(nestedSchema);
		}
		return true;
	});
	return newSchema;
};

const createDynamicSchema = (
	baseSchema,
	fields,
	{
		fieldDotNotationString = 'title',
		requiredDotNotationString = 'isRequired',
	} = {},
) => {
	const newSchema = createNestedDynamicSchema(
		{ ...baseSchema },
		fields,
		fieldDotNotationString,
		requiredDotNotationString,
	);

	const schema = yup.object().shape(newSchema);
	const resolver = yupResolver(schema);
	return { schema, resolver };
};

export default createDynamicSchema;
